/* import __COLOCATED_TEMPLATE__ from './settings.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';

export default class FreshdeskSettingsComponent extends Component {
  @service declare finStandaloneService: FinStandaloneService;

  get freshdeskConfig() {
    return this.finStandaloneService.freshdeskConfig;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Freshdesk::Settings': typeof FreshdeskSettingsComponent;
  }
}
